<div *ngIf="!showDetails">
  <div class="table-toolbar">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Filter</mat-label>
      <input matInput
             placeholder="Search customer, sales order, invoice…"
             (keyup)="applyFilter($any($event.target).value)" />
    </mat-form-field>

    <button mat-stroked-button type="button" (click)="exportCsv()">Export CSV</button>
  </div>

  <div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear>

      <!-- add sequence number -->
      <ng-container matColumnDef="sequence">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let r; let i = index">{{ i + 1 }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Customer -->
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
        <td mat-cell *matCellDef="let r">{{ r.customerName || '—' }}</td>
        <td mat-footer-cell *matFooterCellDef class="total">TOTAL</td>
      </ng-container>

      <!-- Sales Order -->
      <ng-container matColumnDef="salesOrder">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Order</th>
        <td mat-cell *matCellDef="let r">{{ r.salesOrder || '—' }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Invoice -->
      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice</th>
        <td mat-cell *matCellDef="let r">{{ r.invoiceNumber || '—' }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Invoiced Amount -->
      <ng-container matColumnDef="invoicedAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoiced</th>
        <td mat-cell *matCellDef="let r">{{ r.invoicedAmount | currency:'INR':'symbol' }}</td>
        <td mat-footer-cell *matFooterCellDef class="total">
          {{ totals.invoicedAmount | currency:'INR':'symbol' }}
        </td>
      </ng-container>

      <!-- Balance Excluding This Invoice -->
      <ng-container matColumnDef="balanceExcludingThisLoad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Balance (excl.)</th>
        <td mat-cell *matCellDef="let r">{{ r.balanceExcludingThisLoad | currency:'INR':'symbol' }}</td>
        <td mat-footer-cell *matFooterCellDef class="total">
          {{ totals.balanceExcludingThisLoad | currency:'INR':'symbol' }}
        </td>
      </ng-container>

      <!-- Total Outstanding -->
      <ng-container matColumnDef="totalOutstandingForCustomer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Outstanding</th>
        <td mat-cell *matCellDef="let r">{{ r.totalOutstandingForCustomer | currency:'INR':'symbol' }}</td>
        <td mat-footer-cell *matFooterCellDef class="total">
          {{ totals.totalOutstandingForCustomer | currency:'INR':'symbol' }}
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td class="actions" mat-cell *matCellDef="let r">
          <!-- Not delivered yet -->
          <ng-container *ngIf="!r?.delivered; else deliveredChip">
            <button
              *ngIf="load?.state === 'in_transit'"
              mat-flat-button
              color="accent"
              class="btn-deliver"
              (click)="markDelivered(r)"
              [disabled]="processingDeliverId === r?.id"
              matTooltip="Mark this load as delivered"
              aria-label="Deliver"
            >
              <mat-icon *ngIf="processingDeliverId !== r?.id">local_shipping</mat-icon>
              <mat-spinner *ngIf="processingDeliverId === r?.id" [diameter]="18"></mat-spinner>
              <span class="btn-label">Deliver</span>
            </button>
          </ng-container>
        
          <!-- Delivered state -->
          <ng-template #deliveredChip>
            <span
              class="status-chip"
              [ngClass]="{ 'delivered': !isCollected(r), 'collected': isCollected(r) }"
              [title]="isCollected(r) ? 'Collected' : 'Delivered'"
            >
              <mat-icon *ngIf="!isCollected(r)">local_shipping</mat-icon>
              <mat-icon *ngIf="isCollected(r)">task_alt</mat-icon>
              <span>{{ isCollected(r) ? 'Collected' : 'Delivered' }}</span>
            </span>
          </ng-template>          
        </td>
        
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <!-- ⬇️ add (dblclick) on the row -->
      <tr mat-row *matRowDef="let r; columns: displayedColumns;"
          (dblclick)="openInvoiceDetails(r)"
          [class.disabled-row]="!canOpenInvoiceDetails()"
          [class.clickable]="canOpenInvoiceDetails()">
      </tr>

      <tr mat-footer-row *matFooterRowDef="footerColumns" class="footer-row"></tr>
    </table>
  </div>

  <mat-paginator [pageSize]="10"
                 [pageSizeOptions]="[5, 10, 25, 50]"
                 showFirstLastButtons>
  </mat-paginator>
  
  <!-- Start Delivery button when load is in draft -->
  <button *ngIf="load?.state === 'draft' || load?.state === 'loaded'"
          mat-raised-button color="primary"
          class="full-width"
          (click)="startDelivery()">
    Start Delivery
  </button>
  <button mat-raised-button color="accent"
          class="full-width close-button"
          (click)="closeDetails()">
    Close Details
  </button>
</div>
<!-- ⬇️ Details panel (shows the standalone component) -->
<div class="details-panel" *ngIf="showDetails && selectedInvoiceId as id">
  <app-invoice-detail [invoiceId]="id"
                      [loadId] ="load?.id"
                      [showPayments]="true"
                      (invoiceLoaded)="onChildLoaded($event)"
                      (collectPayment)="onChildCollectPayment($event)"
                      (closedDetails)="closeDetails()">
  </app-invoice-detail>
</div>
